import PayrollTable from '../../../components/tables/PayrollTable'
import BenefitsTable from '../../../components/tables/BenefitsTable'
import BenefitMutationsPage from '../../user/Workforce/BenefitMutationsPage'
import React, { useState } from 'react'
import { Flex, VStack } from '@chakra-ui/react'

interface PayrollPageProps {
  selectedTab: string
}

const PayrollPage: React.FC<PayrollPageProps> = ({ selectedTab }) => {
  const [isScrolled, setIsScrolled] = useState(false)

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%">
        {selectedTab === 'people' && <PayrollTable />}
        {selectedTab === 'benefits' && <BenefitsTable />}
        {selectedTab === 'benefit-mutations' && <BenefitMutationsPage />}
      </VStack>
    </Flex>
  )
}

export default PayrollPage
